import { VariableName } from "./typeBrands.js";

// added to replace `as VariableName` so we see errors if casting null or undefined values
// we should only be casting strings to VariableName's
export const safeCastVariableName = (name: string): VariableName => {
  return name as VariableName;
};
